import Tag from 'shared-web/src/components/Tag'
import { pluralize } from 'humanize-plus'
import Icon from 'svg-inline-react'
import { Button, Loader } from '@driftt/tide-core-legacy'
import cx from 'classnames'

import { MarketingEmailLayouts, EmailPreviewView } from 'app/modules/playbook/constants'
import FakeEmailWindow from 'components/shared/FakeEmailWindow'
import UISelect from 'components/shared/UISelect'

import twitter from 'images/svg/twitter.svg'
import linkedin from 'images/svg/linkedin.svg'
import facebook from 'images/svg/facebook.svg'
import infoSrc from '!svg-inline?removeSVGTagAttrs=false&removeTags=true!images/icons/info-icon.svg'

const HELP_DOC_LINK = 'https://help.drift.com/article/personalization-tokens/'
const HELP_LINK_TEXT = 'Click here to learn more about using personalization attributes in a Drift playbook.'

import './style.styl'

const EmailFrom = ({ isOutboundSequencePlaybook, currentUserName, fromName, fromEmail, isDynamicSender }) => {
  const name = isOutboundSequencePlaybook ? currentUserName : fromName
  if (isDynamicSender) {
    return <Tag
      className="playbook-email-edit-dynamic-sender-attrib"
      tag={{ name: `{{ account.${fromName} }}` }}
    />
  } else {
    return <span>{name}</span>
  }
}

const MarketingEmailFooter = ({
  orgTwitterUrl,
  orgLinkedinUrl,
  orgFacebookUrl,
  orgName,
  orgAddress,
  showBranding
}) => (
  <div className="playbook-email-template-footer">
    {/* NOTE: styles here come from EmailEditCard/style.styl  */}
    <div className="playbook-email-edit-footer">
      <div className="playbook-email-edit-social-links">
        {!!orgTwitterUrl &&
          <a target="_blank" href={orgTwitterUrl}><img src={twitter}/></a>
        }
        {!!orgLinkedinUrl &&
          <a target="_blank" href={orgLinkedinUrl}><img src={linkedin} /></a>
        }
        {!!orgFacebookUrl &&
          <a target="_blank" href={orgFacebookUrl}><img src={facebook} /></a>
        }
      </div>
      <div className="playbook-email-edit-footer-text">{orgName}</div>
      <div className="playbook-email-edit-footer-text-small playbook-email-edit-footer-text">{orgAddress}</div>
      <div className="playbook-email-edit-footer-text-muted"><a>Click here to unsubscribe</a></div>
      {showBranding && <p className="playbook-email-edit-footer-poweredby">Email ⚡️ by Drift</p>}
    </div>
  </div>

)

const EmailWithLogoBody = ({
  message,
  orgName,
  orgLogoUrl,
  orgTwitterUrl,
  orgLinkedinUrl,
  orgFacebookUrl,
  orgAddress,
  backgroundColor,
  getPreviewMessage,
  emailId,
  showBranding
}) => (
  <div className="playbook-email-template-with_logo-preview">
    <div className="playbook-email-template-header">
      <img src={orgLogoUrl} />
    </div>
    <div className="playbook-email-template-body" dangerouslySetInnerHTML={{ __html: getPreviewMessage(emailId, message) }} style={{ borderTopColor: backgroundColor }} />
    <MarketingEmailFooter
      orgName={orgName}
      orgAddress={orgAddress}
      orgTwitterUrl={orgTwitterUrl}
      orgLinkedinUrl={orgLinkedinUrl}
      orgFacebookUrl={orgFacebookUrl}
      showBranding={showBranding}
    />
  </div>
)

const EmailWithHeroBody = ({
  message,
  orgName,
  bannerImageUrl,
  orgTwitterUrl,
  orgLinkedinUrl,
  orgFacebookUrl,
  orgAddress,
  getPreviewMessage,
  emailId,
}) => (
  <div className="playbook-email-template-with_hero-preview">
    <div className="playbook-email-template-with_hero-body">
      <div className="playbook-email-template-header">
        <img src={bannerImageUrl} />
      </div>
      <div className="playbook-email-template-body" dangerouslySetInnerHTML={{ __html: getPreviewMessage(emailId, message) }} />
    </div>
    <MarketingEmailFooter
      orgName={orgName}
      orgAddress={orgAddress}
      orgTwitterUrl={orgTwitterUrl}
      orgLinkedinUrl={orgLinkedinUrl}
      orgFacebookUrl={orgFacebookUrl}
    />
  </div>
)

const EmailBody = ({
  isMarketingSequencePlaybook,
  isOutboundSequencePlaybook,
  marketingEmailLayout,
  selectedPreview,
  isTemplateContactPreviewLoading,
  ...props
}) => (
  <div className={cx('playbook-email-template-content', { 'playbook-email-template-preview': selectedPreview !== EmailPreviewView.TEMPLATE, 'playbook-email-template-preview-loading' : isTemplateContactPreviewLoading})}>
    {isTemplateContactPreviewLoading && <Loader />}

    {isMarketingSequencePlaybook && marketingEmailLayout === MarketingEmailLayouts.WITH_COMPANY_LOGO &&
      <EmailWithLogoBody {...props} />
    }

    {(isOutboundSequencePlaybook || isMarketingSequencePlaybook && marketingEmailLayout === MarketingEmailLayouts.SIMPLE || marketingEmailLayout === null) &&
      <div dangerouslySetInnerHTML={{ __html: props.getPreviewMessage(props.emailId, props.message) }} />
    }

    {isMarketingSequencePlaybook && marketingEmailLayout === MarketingEmailLayouts.WITH_HERO_IMAGE &&
      <EmailWithHeroBody {...props} />
    }
  </div>
)


const EmailPreview = ({
  email,
  index,
  currentUserName,
  currentUserEmail,
  isOutboundSequencePlaybook,
  getFromName,
  getFromEmail,
  getIsDynamicSender,
  ...props,
}) => {
  const isFirstEmail = index === 0
  return <div>
    { !isFirstEmail && email.delay > 0 &&
      <div className="playbook-email-preview-sequence-delay">After {email.delay} {pluralize(email.delay, 'day', 'days')}, send:</div>
    }
    <FakeEmailWindow
      from={
        <EmailFrom
          currentUserName={currentUserName}
          currentUserEmail={currentUserEmail}
          isOutboundSequencePlaybook={isOutboundSequencePlaybook}
          fromName={getFromName(email)}
          fromEmail={getFromEmail(email)}
          isDynamicSender={getIsDynamicSender(email)}
        />
      }
      address={isOutboundSequencePlaybook ? currentUserEmail : getFromEmail(email)}
      subject={email.title}
    >
      <EmailBody
        className="playbook-email-template-content"
        message={email.message}
        emailId={email.id}
        bannerImageUrl={email.bannerImageUrl}
        isOutboundSequencePlaybook={isOutboundSequencePlaybook}
        {...props}
      />
    </FakeEmailWindow>
  </div>
}

const SequenceRenderPreview = ({
  onTemplatePreviewClick,
  isMarketingSequencePlaybook,
  selectedPreview,
  onDefaultPreviewClick,
  onRenderedPreviewClick,
  userListIdOptions,
  selectedUserListOption,
  handleChangeUserListOption,
  isTemplateContactPreviewLoading,
  onRefreshPreviewClick,
  hasLimitedContactsMktEmail,
}) => (
  <div>
    <div className="sequence-playbook-extra-option">
      <div className="sequence-playbook-preview-options">
        <label className="sequence-playbook-preview-options-label">
          Preview Sample Data{' '}
          <a is href={HELP_DOC_LINK} tooltip={HELP_LINK_TEXT} flow="down" target="_blank">
            <Icon src={infoSrc} />
          </a>
        </label>
        <div className="tide-pill-set sequence-playbook-preview-data-pills">
          <Button onClick={onTemplatePreviewClick} type="subtle" selected={selectedPreview === EmailPreviewView.TEMPLATE}>
            Template
          </Button>
          <Button onClick={onDefaultPreviewClick} type="subtle" selected={selectedPreview === EmailPreviewView.DEFAULTS}>
            Defaults
          </Button>
          {isMarketingSequencePlaybook && hasLimitedContactsMktEmail &&
            <Button onClick={onRenderedPreviewClick} type="subtle" selected={selectedPreview === EmailPreviewView.RENDERED_DATA}>
              Contact
            </Button>
          }
        </div>
      </div>
    </div>
    {selectedPreview === EmailPreviewView.RENDERED_DATA && (
      <div className="sequence-playbook-segment-option">
        <UISelect
          className="playbook-email-preview-segment-select"
          options={userListIdOptions}
          value={selectedUserListOption}
          onChange={handleChangeUserListOption}
          placeholder={'choose a segment..'}
        />
        <div>
          <Button type="subtle" onClick={onRefreshPreviewClick} disabled={isTemplateContactPreviewLoading} loading={isTemplateContactPreviewLoading}>Refresh</Button>
        </div>
      </div>
    )}
  </div>
)


export const SequencePreview = ({
  sequence,
  emails,
  ...props,
}) => (
  <div className="playbook-edit-sequence-preview">
    <SequenceRenderPreview {...props} />
      {sequence.emails.map((emailId, index) => {
        const email = emails.get(emailId)
        return <EmailPreview key={email.id} email={email} options={sequence.options} index={index} {...props} />
      })}
  </div>
)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/SequencePreview/component.js